import {suggest} from '../plugins/dadata.js'

const inputTimeout = 300;
let lastSuggestEvent = null;
export default {
    mounted(el, binding) {
        let suggestPath = '';

        switch (binding.value) {
            case 'address':
                suggestPath = 'address';
                break;
            case 'inn':
            case 'party':
                suggestPath = 'party';
                break
            case 'bank':
                suggestPath = 'bank';
                break
            default:
                suggestPath = '';
        }

        if (suggestPath) {

            let suggestTimeout = null;
            let suggestDiv = document.createElement('div');
            suggestDiv.classList.add('suggestList');

            el.addEventListener('input', (event) => {
                if (event.detail === 'custom') {
                    return;
                }
                clearTimeout(suggestTimeout);
                suggestTimeout = setTimeout(() => {
                    suggestDiv.innerHTML = '';
                    suggest(suggestPath, event.target.value)
                        .then((suggestList) => {
                            lastSuggestEvent = new CustomEvent('suggest', {
                                bubbles: true,
                                cancelable: true,
                                detail: suggestList
                            });
                            el.dispatchEvent(lastSuggestEvent);
                        })
                }, inputTimeout);
            })
            el.addEventListener('suggest', (suggestEvent) => {
                let suggestList = suggestEvent.detail.suggestions;
                suggestDiv.innerHTML = '<span>Выберите вариант или продолжите ввод</span>\n';

                for (let item of suggestList) {
                    let suggestRow = document.createElement('a');
                    suggestRow.classList.add('suggestList-item');

                    let result = highlight(item.value, el.value) + ' <br/>';
                    if (binding.value === 'inn' || binding.value === 'party') {
                        result += '<small>' + highlight(item.data.inn, el.value) + ', ' + highlight(item.data.address.value, el.value) + '</small>';
                    }
                    if (binding.value === 'bank') {
                        result += '<small>' + highlight(item.data.bic, el.value) + ', ' + highlight(item.data.address.value, el.value) + '</small>'
                    }
                    suggestRow.innerHTML = result
                    suggestDiv.appendChild(suggestRow)

                    suggestRow.addEventListener('click', () => {
                        if (binding.value === 'inn' || binding.value === 'party') {
                            el.value = item.data.inn
                        }
                        if (binding.value === 'address') {
                            el.value = item.value
                        }
                        if (binding.value === 'bank') {
                            el.value = item.data.bic
                        }
                        el.dispatchEvent(new CustomEvent('input', {'detail': 'custom'}))

                        let suggestSelectEvent = new CustomEvent('suggestSelect', {
                            detail: item
                        })
                        el.dispatchEvent(suggestSelectEvent)
                        suggestDiv.innerHTML = ''
                    })
                }
                el.after(suggestDiv)
            });
            document.addEventListener('click', (event) => {
                if (event.target !== el && !event.target.closest('.suggestList')) {
                    suggestDiv.innerHTML = '';
                }
            })
            el.showSuggest = () => {
                el.dispatchEvent(new Event('input'));
            }
            el.showLastSuggest = () => {
                el.dispatchEvent(lastSuggestEvent);
            }
        }
    },
}
const highlight = (string, inputValue) => {
    let trigger = inputValue.replace(/<\/?small>|<\/?b>|<br\/?>|[<>]|br|b|small|r|^\/+/g, "").trim();
    if (trigger) {
        trigger = trigger.split(' ');
        trigger.forEach((str) => {
            if (str !== '/') {
                string = string.replaceAll(str, '<b>' + str + '</b>');
                str = str.substr(0, 1).toUpperCase() + str.substr(1);
                string = string.replaceAll(str, '<b>' + str + '</b>');
            }
        });
    }

    return string;
}
